export default __webpack_public_path__ + "static/media/Musica-mujer.53128825.svg";